module.exports = __webpack_public_path__ + "img/hkcard.png";